import React from 'react'
import './player-quest-item.styles.scss';
import { stripHtml } from '@/utils/sanitize';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const PlayerQuestItem = ({
  quest,
  onClick,
}) => {

  return (
    <div className='player-quest-item-wrapper'>
      <div
        className={`player-quest-item g-list-item clickable with-shadow${quest.questStatus === 'inProgress' ? ' in-progress' : ''}`}
        onClick={onClick}
      >
        <div className='quest-icon-wrapper'>
          <ImageContainer
            src={quest.icon || '/images/icons/quests.png'}
            alt={`${quest.name} quest icon`}
            className='quest-icon'
          />
          {quest.questStatus === 'complete' && (
            <ImageContainer
              src='/images/icons/completed-overlay-green.png'
              alt='completed overlay'
              className='quest-completed-overlay'
            />
          )}
        </div>
        <div className='quest-name'>
          {quest.name}
          {quest.questStatus === 'inProgress' && (
            <div className='quest-in-progress-badge'>In Progress</div>
          )}
        </div>
        <div className='quest-desc'>
          {
            quest.desc && stripHtml(quest.desc).substring(0, 40)
          }
          {
            quest.desc && stripHtml(quest.desc).length > 40
              ? '...'
              : ''
          }
        </div>
      </div>
    </div>
  )
}

export default PlayerQuestItem
